import { AMPLITUDE_EXPERIMENT_VARIANT_NAME } from '@constants/amplitudeExperiments';
import { ExperimentType } from '@customTypes/context';
import React, { ReactNode, MouseEventHandler, useMemo } from 'react';

type Props = {
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  classes?: string;
  isDisabled?: boolean;
  fixedDateSelectorExperiment?: ExperimentType;
};

const defaultProps = {
  classes: '',
  isDisabled: false,
  fixedDateSelectorExperiment: null,
};

export default function ButtonBlackRoundedCorners({
  onClick,
  children,
  classes,
  isDisabled,
  fixedDateSelectorExperiment,
}: Props) {
  const baseStyles = useMemo(
    () =>
      (fixedDateSelectorExperiment === AMPLITUDE_EXPERIMENT_VARIANT_NAME
        ? 'w-full h-full flex justify-center items-center bg-rp-primary py-4 rounded-xl text-white font-rp-pn-semi-bold'
        : 'w-full h-full flex justify-center items-center bg-rp-primary-black hover:bg-rp-primary-black-medium active:bg-black py-4 rounded-xl text-white font-rp-pn-semi-bold'),
    [fixedDateSelectorExperiment],
  );
  return (
    <button
      type="button"
      className={`${classes} ${baseStyles} ${
        isDisabled ? 'opacity-50 pointer-events-none' : 'pointer-events-auto opacity-100'
      }`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

ButtonBlackRoundedCorners.defaultProps = defaultProps;
